Namespace.create('cv.Views.Post').ConfirmPublishView = Marionette.LayoutView.extend({
  id: 'modal-confirm-publish-post',

  template: cv.Templates['post/confirm_publish'],

  behaviors : [{
    behaviorClass : cv.FormBehavior
  }],

  events : {
    'click .edit-share' : 'editShare'
  },

  validation: {
    share_post : []
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.model = new Backbone.Model();

    this.listenTo(this, 'form:saved', function(){
      this.trigger('confirm');
      vent.trigger('modal:hide');
    }, this);

    console.log('ConfirmPublishView initialized');
  },

  editShare: function(e){
    e.preventDefault();

    // Close modal
    vent.trigger('modal:hide');

    // Trigger the URL
    cv.adminRouter.navigate('posts/edit/' + this.options.post_id + '/share', { trigger : true });
  },

  templateHelpers: function(){
    return {
    };
  }
});
